import React from 'react'
import Ui from '../../../presentationals/Admin/NbfcManagementNew/nbfcDetails'
class BasicDetails extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    componentDidMount(){

    }
    render(){
        return(
            <div>
                <Ui
                nbfcData={this.props.nbfcData}
                />
            </div>
        )
    }
}
export default BasicDetails